import { AccessibilityColorScheme } from './types';

// Константы должны совпадать с именами классов в globalStyles.scss
export const COLOR_SCHEME_CLASSNAMES: Record<AccessibilityColorScheme, string> = {
  base: 'color-scheme-base',
  inverse: 'color-scheme-inverse',
  blue: 'color-scheme-blue',
  beige: 'color-scheme-beige',
  green: 'color-scheme-green',
} as const;
